import { baseApiAuth as api } from "./baseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    listTenantsTenantsGet: build.query<
      ListTenantsTenantsGetApiResponse,
      ListTenantsTenantsGetApiArg
    >({
      query: (queryArg) => ({
        url: `/tenants`,
        params: {
          email: queryArg.email,
        },
      }),
    }),
    listMaterializedZoneAssociationsZonesGet: build.query<
      ListMaterializedZoneAssociationsZonesGetApiResponse,
      ListMaterializedZoneAssociationsZonesGetApiArg
    >({
      query: () => ({ url: `/zones` }),
    }),
    isUserMemberOfZoneZonesZoneIdAssociatedGet: build.query<
      IsUserMemberOfZoneZonesZoneIdAssociatedGetApiResponse,
      IsUserMemberOfZoneZonesZoneIdAssociatedGetApiArg
    >({
      query: (queryArg) => ({ url: `/zones/${queryArg.zoneId}/associated` }),
    }),
    jwtDebugJwtDebugGet: build.query<
      JwtDebugJwtDebugGetApiResponse,
      JwtDebugJwtDebugGetApiArg
    >({
      query: () => ({ url: `/jwt-debug` }),
    }),
    getAuthenticatedUserUserGet: build.query<
      GetAuthenticatedUserUserGetApiResponse,
      GetAuthenticatedUserUserGetApiArg
    >({
      query: () => ({ url: `/user` }),
    }),
    updateAuthenticatedUserUserPatch: build.mutation<
      UpdateAuthenticatedUserUserPatchApiResponse,
      UpdateAuthenticatedUserUserPatchApiArg
    >({
      query: (queryArg) => ({
        url: `/user`,
        method: "PATCH",
        body: queryArg.userSelfUpdate,
      }),
    }),
    resetPasswordUserResetPasswordPost: build.mutation<
      ResetPasswordUserResetPasswordPostApiResponse,
      ResetPasswordUserResetPasswordPostApiArg
    >({
      query: () => ({ url: `/user/reset-password`, method: "POST" }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as auth };
export type ListTenantsTenantsGetApiResponse =
  /** status 200 Successful Response */ ListResponseAuthTenant;
export type ListTenantsTenantsGetApiArg = {
  email?: string | null;
};
export type ListMaterializedZoneAssociationsZonesGetApiResponse =
  /** status 200 Successful Response */ ListResponseZone;
export type ListMaterializedZoneAssociationsZonesGetApiArg = void;
export type IsUserMemberOfZoneZonesZoneIdAssociatedGetApiResponse =
  /** status 200 Successful Response */ boolean;
export type IsUserMemberOfZoneZonesZoneIdAssociatedGetApiArg = {
  zoneId: string;
};
export type JwtDebugJwtDebugGetApiResponse =
  /** status 200 Successful Response */ any;
export type JwtDebugJwtDebugGetApiArg = void;
export type GetAuthenticatedUserUserGetApiResponse =
  /** status 200 Successful Response */ ResponseUser;
export type GetAuthenticatedUserUserGetApiArg = void;
export type UpdateAuthenticatedUserUserPatchApiResponse =
  /** status 200 Successful Response */ ResponseUser;
export type UpdateAuthenticatedUserUserPatchApiArg = {
  userSelfUpdate: UserSelfUpdate;
};
export type ResetPasswordUserResetPasswordPostApiResponse =
  /** status 200 Successful Response */ ActionResponse;
export type ResetPasswordUserResetPasswordPostApiArg = void;
export type AuthTenant = {
  tenant_id: string;
  tenant_name: string;
  client_id: string;
};
export type ListResponseAuthTenant = {
  object?: "list";
  data?: AuthTenant[];
};
export type ValidationError = {
  loc: (string | number)[];
  msg: string;
  type: string;
};
export type HttpValidationError = {
  detail?: ValidationError[];
};
export type NightReportTimes = {
  start?: string;
  end?: string;
};
export type ZoneSettings = {
  night_report_times?: NightReportTimes | null;
};
export type Zone = {
  id: string;
  object?: "zone";
  tenant_id: string;
  parent_id?: string | null;
  path: string;
  level?: number | null;
  name: string;
  description?: string | null;
  /** You can use this parameter to attach key-value data.
    You can specify up to 50 keys, with key names up to 40 characters long and values up to 500 characters long.
    
    Metadata is useful for storing additional, structured information on an object. As an example, you could store
    your user's emergency contact name or corresponding unique identifiers from your system.
    Metadata is not used by the backend, and won't be seen by your users unless you choose to show it to them.
    
    Do not store any sensitive information (social security numbers, bank account numbers, etc.) as metadata.
     */
  metadata?: {
    [key: string]: any;
  };
  settings?: ZoneSettings | null;
  created_at: string;
  updated_at: string;
};
export type ListResponseZone = {
  object?: "list";
  data?: Zone[];
};
export type UserState = "pending" | "active" | "inactive";
export type UserRole =
  | "OWNER"
  | "ADMIN"
  | "MANAGER"
  | "MANAGER_LIMITED"
  | "DATA_READER"
  | "DATA_READER_LIMITED"
  | "SERVICE_MONITOR";
export type EmbeddedZones = {
  object?: "list";
  data?: Zone[];
};
export type User = {
  id: string;
  object?: "user";
  state: UserState;
  email: string;
  first_name?: string | null;
  last_name?: string | null;
  profession?: string | null;
  roles: UserRole[];
  zones?: EmbeddedZones | null;
  preferences?: {
    [key: string]: any;
  };
  metadata?: {
    [key: string]: any;
  };
  created_at: string;
  updated_at: string;
};
export type ResponseUser = {
  data?: User;
};
export type UserSelfUpdate = {
  email?: string | null;
  first_name?: string | null;
  last_name?: string | null;
  profession?: string | null;
  preferences?: {
    [key: string]: any;
  };
};
export type Result = "failed" | "success";
export type ActionResponse = {
  result: Result;
};
export const {
  useListTenantsTenantsGetQuery,
  useListMaterializedZoneAssociationsZonesGetQuery,
  useIsUserMemberOfZoneZonesZoneIdAssociatedGetQuery,
  useJwtDebugJwtDebugGetQuery,
  useGetAuthenticatedUserUserGetQuery,
  useUpdateAuthenticatedUserUserPatchMutation,
  useResetPasswordUserResetPasswordPostMutation,
} = injectedRtkApi;
